import React, { Component } from 'react';

export default class Footer extends Component {


    render() {
        return ( 
        <div>
            <div className="footer-email  dark-bg">
                <div className="boletin__section footer__section">
                    <div className="row align-items-center">
                    <div className="col-sm-8">
                        <p className="footer__address">
                        Calle 21 N° 713 Urb. Corpac - San Isidro - Lima - Perú
                        </p>
                        <p className="footer__address">
                        Av. Jorge Basadre 610 - San Isidro - Lima - Perú
                        </p>
                        <p className="footer__address">
                        Teléfonos: (511) 6167300 - 6167400
                        </p>
                    </div>
                    <div className="col-sm-4 footer__logo">
                        <img alt="PromPerú" src="/img/PP_logo_blanco.png" />
                    </div>
                    </div>
                </div>
            </div>
            <div className="footer-copyright">
                <div className="boletin__section footer-copyright__section">
                    <div className="row align-items-center">
                    <div className="col-sm-8">
                        Administración | Términos de Uso | Copyright 2020 PROMPERÚ | Óptima Vizualización
                    </div>
                    <div className="col-sm-4 copyright__logo">
                        <img alt="Mincetur" src="/img/logo-mincetur.png" />
                    </div>
                    </div>
                </div>
            </div>
        </div>)
    }

}